console.log("Vite ⚡️ Rails");
console.log("Visit the guide for more information: ", "https://vite-ruby.netlify.app/guide/rails");

//=========================================================================
// Rails, Turbo, and ActiveStorage
//=========================================================================
import * as Turbo from "@hotwired/turbo";
Turbo.start();

// import ActiveStorage from "@rails/activestorage";
// ActiveStorage.start();

//=========================================================================
// StimulusJS
//=========================================================================
import { Application } from "stimulus";
import { registerControllers } from "stimulus-vite-helpers";

const application = Application.start();
const controllers = import.meta.glob("@/controllers/*_controller.js", { eager: true });
registerControllers(application, controllers);

// Import and register all TailwindCSS Components
import { Dropdown, Modal, Tabs, Popover } from "tailwindcss-stimulus-components";
// application.register('dropdown', Dropdown)
application.register("modal", Modal);
application.register("tabs", Tabs);
// application.register('popover', Popover)

// Flatpickr-Stimulus
import Flatpickr from "stimulus-flatpickr";
application.register("flatpickr", Flatpickr);

//=========================================================================
// Stylesheets
//=========================================================================
import "tailwindcss/base.css";
import "tailwindcss/components.css";

import "@fortawesome/fontawesome-free/css/fontawesome.css";
import "@fortawesome/fontawesome-free/css/regular.css";
import "@fortawesome/fontawesome-free/css/solid.css";
import "@fortawesome/fontawesome-free/css/brands.css";

import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";

import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import "@uppy/webcam/dist/style.css";

import "flatpickr/dist/flatpickr.css";
import "tom-select/dist/css/tom-select.css";
import "tom-select/dist/css/tom-select.bootstrap5.css";
import "toastr/build/toastr.css";

import "@/stylesheets/components/badges.css";
import "@/stylesheets/components/buttons.css";
import "@/stylesheets/components/forms.css";
import "@/stylesheets/components/links.css";
import "@/stylesheets/components/tabs.css";
import "@/stylesheets/components/tables.css";
import "@/stylesheets/components/navbar.css";
import "@/stylesheets/components/mobile_menu.css";
import "@/stylesheets/components/selectize.css";

import "tailwindcss/utilities.css";

import "@/stylesheets/application.css";
